import React from "react"

import { ArrowLeft } from "lucide-react"
import { Navigate, useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/AuthContext"
import CollectionsLayout from "@/layouts/CollectionsLayout"

/** The isAdmin redirect is cosmetic; RLS and the re-export role check enforce access. */
const AdminPage: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAdmin } = useAuth()
  const navigate = useNavigate()

  if (!isAdmin) return <Navigate to="/collections/monitoring" replace />

  return (
    <CollectionsLayout>
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex-shrink-0 border-b border-palette-jungleGreen200 bg-white px-6 py-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/collections/monitoring")}
            className="gap-2 text-palette-jungleGreen600"
          >
            <ArrowLeft size={14} aria-hidden="true" />
            Back to collections
          </Button>
        </div>
        {children}
      </div>
    </CollectionsLayout>
  )
}

export default AdminPage
